import { Component } from '@angular/core';
import { NgIcon } from '@ng-icons/core';

@Component({
    selector: 'app-preview-banner',
    standalone: true,
    imports: [NgIcon],
    templateUrl: './preview-banner.component.html',
    styleUrl: './preview-banner.component.scss',
})
export class PreviewBannerComponent {}
